import AppLabelordersIndex from "./labelorder.vue";
import AppLabelordersList from "./list/list.vue";
import AppLabelordersItem from "./item/item.vue";

const routes = [
  {
    path: "/labelorder",
    component: AppLabelordersIndex,
    meta: {
      auth: {
        roles: "labelrder.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "labelorder.index",
        component: AppLabelordersList,
        meta: {
          auth: {
            roles: "labelOrder.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "labelorder.create",
        component: AppLabelordersItem,
        meta: {
          auth: {
            roles: "labelOrder.create",
            redirect: { name: "labelorder.index" }
          }
        }
      }
      // {
      //   path: ":id",
      //   name: "labelorder.edit",
      //   component: AppLabelordersItem,
      //   meta: {
      //     auth: {
      //       roles: "labelOrder.update",
      //       redirect: { name: "labelorder.index" }
      //     }
      //   }
      // }
    ]
  }
];

export default routes;
